// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData__ContactData__1J81r"};